<script>
export default {
    name: "CashPaymentForm",

    props: {
        cashModes: Array,
        cashCOAs: Array,
        payment: Object,
        errors: Array,
        totalAmount: Number
    }
}
</script>
<template>
    <div class="w-full flex flex-wrap">
        <div class="md:w-1/4 w-1/2 p-tiny">
            <label for="grid-cash-account" class="label-control">Account:</label>
            <tail-select>
                <template v-slot:field>
                    <select v-model="payment.accountID" 
                        id="grid-cash-account" class="input-control input-sm text-xs">
                        <option 
                            v-for="(cashCOA,idx) in cashCOAs" 
                            :key="idx" :value="cashCOA.coaid">{{ cashCOA.coaName }}</option>
                    </select>
                </template>
            </tail-select>
            <p class="form-text-error" 
                v-if="errors.filter(error => error.field == 'accountID').length">
                  {{ errors.filter(error => error.field == 'accountID')[0].message }}</p>
        </div>
        <div class="md:w-1/4 w-1/2 p-tiny">
            <label for="grid-cash-mode" class="label-control">Mode:</label>
            <tail-select>
                <template v-slot:field>
                    <select v-model="payment.paymentModeID" 
                        id="grid-cash-mode" class="input-control input-sm text-xs">
                        <option 
                            v-for="(cashMode,idx) in cashModes" 
                            :key="idx" :value="cashMode.pModeID">{{ cashMode.mode }}</option>
                    </select>
                </template>
            </tail-select>
            <p class="form-text-error" 
                v-if="errors.filter(error => error.field == 'paymentModeID').length">
                  {{ errors.filter(error => error.field == 'paymentModeID')[0].message }}</p>
        </div>
        <div class="md:w-1/5 w-1/2 p-tiny">
            <label for="grid-cash-amount" class="label-control">Amount:</label>
            <input type="number" 
                id="grid-cash-amount" :value="totalAmount" disabled class="input-control input-sm text-xs disabled">
            <p class="form-text-error" 
                v-if="errors.filter(error => error.field == 'amount').length">
                  {{ errors.filter(error => error.field == 'amount')[0].message }}</p>
        </div>
    </div>
</template>
